(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('passengersTransactionsController', passengersTransactionsController);

    passengersTransactionsController.$inject = ['$stateParams', 'datePickerService', '$translate',
        'currencies', 'regions', 'tabs', 'typeTransaction', 'branchOfficeService', 'linkService', 'dateService',
        'transactionsService', 'userService', 'printService', 'userSession', 'excelService'];

    function passengersTransactionsController($stateParams, datePickerService, $translate, currencies, regions, tabs,
                                              typeTransaction, branchOfficeService, linkService, dateService,
                                              transactionsService, userService, printService, userSession, excelService){
        var vm = this;
        vm.regionAll = [{name: 'Todas', initial: 'all'}];
        vm.branchOfficeAll = [{name: 'Todas', regionId: 0}];
        vm.userAll = [{name: 'Todas', userId: 0}];
        vm.currencies = currencies;
        vm.regions = (regions.data._embedded) ? regions.data._embedded.regions : [];
        vm.userSession = userSession.data;
        if(vm.userSession.positionType == "GENERAL_ADMIN"){
            vm.regions = vm.regionAll.concat(vm.regions);
        }else{
            vm.regions = getRegions(vm.regions,vm.userSession._embedded.branchOffices);
        }
        vm.branchOffices = [];
        vm.users = [];
        vm.tabs = tabs;
        vm.typeTransaction = typeTransaction;

        vm.datePickerOpenStatus = {
            fromDate: false,
            toDate: false
        };
        vm.pickerButtons = datePickerService.pickerButtons();

        vm.datepickerFromDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            },
            closed: function(args) {
                if (args.closeDate != null && !vm.filterPassages.detail) {
                    var dateAux = new Date(args.closeDate);
                    var maxDate = new Date(dateAux.setDate(dateAux.getDate() + 30));
                    vm.datepickerToDate.datepickerOptions.minDate = args.closeDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                    vm.filterPassages.toDate = args.closeDate;
                }
            }
        };

        vm.datepickerToDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            }
        };

        vm.filterPassages = transactionsService.transactionFilter();
        vm.transactionPassages = transactionsService.transactionModel();/*{
            currency: null,
            region: null,
            branchOffice: null,
            user: null,
            rate: true,
            detail: true,
            fromDate: null,
            toDate: ''
        };*/

        vm.disabledUserBranch = false;
        vm.isBranch = false;
        vm.isReport = false;
        vm.isGeneralOrRegional = userService.isGeneralOrRegional(vm.userSession.positionType);
        vm.isDownload = false;
        vm.reportTransactionPassengerHtml = '';
        vm.toDate = null;
        vm.type = '';

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.onChangeDetail = function () {
            vm.datepickerFromDate.datepickerOptions.minDate = null;
            vm.datepickerFromDate.datepickerOptions.maxDate = new Date();
            vm.datepickerToDate.datepickerOptions.minDate = null;
            vm.datepickerToDate.datepickerOptions.maxDate = new Date();
            vm.filterPassages.toDate = null;
            vm.filterPassages.fromDate = null;
        }

        vm.onChangeRegion = function() {
            var region = vm.filterPassages.region;
            if (region !== null && region !== undefined) {
                if (region.initial === 'all') {
                    vm.disabledUserBranch = true;
                    if (vm.typeTransaction === 'branch') {
                        vm.branchOffices = vm.branchOfficeAll;
                        vm.filterPassages.branchOffice = vm.branchOffices[0];
                    } else {
                        vm.users = vm.userAll;
                        vm.filterPassages.user = vm.users[0];
                    }
                } else {
                    vm.disabledUserBranch = false;
                    if (vm.typeTransaction === 'branch') {
                        vm.branchOffices = [];
                        branchOfficeService.getBranchOfficesByRegion(linkService.getLinkId(region._links.self.href))
                            .then(function (response) {
                                var res = (response.data._embedded) ? response.data._embedded.branchOffices : [];
                                if(vm.userSession.positionType == "GENERAL_ADMIN" || vm.userSession.positionType == "REGIONAL_ADMIN"){
                                    vm.branchOffices = vm.branchOfficeAll.concat(res);
                                }else{
                                    vm.branchOffices = getBranchOffices(res,vm.userSession._embedded.branchOffices);
                                }
                            });
                    } else {
                        vm.users = [];
                        userService.getUsersByRegion(linkService.getLinkId(region._links.self.href))
                            .then(function (response) {
                                var res = (response.data) ? response.data : [];
                                if(vm.userSession.positionType == "GENERAL_ADMIN" || vm.userSession.positionType == "REGIONAL_ADMIN"){
                                    vm.users = vm.userAll.concat(res);
                                }else{
                                    vm.users = getUsers(res,vm.userSession);
                                }
                            });
                    }
                }
            } else {
                vm.disabledUserBranch = false;
                vm.branchOffices = [];
                vm.users = [];
            }

        }

        vm.cancelSalesBook = function (formGenerateSalesBook) {
            vm.filterSalesBook.taxpayer = null;
            vm.filterSalesBook.economicActivity = null;
            vm.filterSalesBook.management = null;
            formGenerateSalesBook.$setPristine();
        }

        vm.generateTransactionPassenger = function (isValid, formGenerateArching) {
            if(isValid){
                vm.transactionPassages.fromDate = dateService.dateTimeString(vm.filterPassages.fromDate, 1);
                vm.transactionPassages.toDate = (!vm.filterPassages.detail) ? dateService.dateTimeString(vm.filterPassages.toDate, 2) : '';
                vm.transactionPassages.currency = vm.filterPassages.currency.code;
                vm.transactionPassages.region = (vm.filterPassages.region.initial === 'all') ? '' : linkService.getLinkId(vm.filterPassages.region._links.self.href);
                vm.transactionPassages.airRate = vm.filterPassages.rate;
                vm.transactionPassages.detail = vm.filterPassages.detail;


                if (vm.typeTransaction === 'branch') {
                    vm.transactionPassages.branch = true;
                    vm.transactionPassages.employee = '';
                    vm.transactionPassages.branchOffice = (vm.filterPassages.branchOffice.name === 'Todas') ? '' : linkService.getLinkId(vm.filterPassages.branchOffice._links.self.href);
                } else {
                    vm.transactionPassages.branch = false;
                    vm.transactionPassages.employee = (vm.filterPassages.user.name === 'Todas') ? '' : vm.filterPassages.user.login;
                    vm.transactionPassages.branchOffice = '';
                }
                transactionsService.getTransactionsPassages(vm.transactionPassages).then(function (response) {
                    if(response !== undefined) {
                        vm.reportTransactionPassengerHtml = response.data;
                        vm.isReport = true;
                    } else {
                        vm.isReport = false;
                    }
                });
            }
        }

        vm.generateTransactionChannel = function (isValid, formGenerateArching) {
            if(isValid) {
                vm.transactionPassages.fromDate = dateService.dateTimeString(vm.filterPassages.fromDate, 1);
                vm.transactionPassages.toDate = (!vm.filterPassages.detail) ? dateService.dateTimeString(vm.filterPassages.toDate, 2) : '';
                vm.transactionPassages.detail = vm.filterPassages.detail;
                if(vm.filterPassages.detail) {
                    vm.transactionPassages.toDate = dateService.dateTimeString(vm.filterPassages.fromDate, 1);
                }
                transactionsService.getTransactionsPassagesChannel(vm.transactionPassages).then(function (response) {
                    if(response !== undefined) {
                        vm.reportTransactionPassengerHtml = response.data;
                        vm.isReport = true;
                    } else {
                        vm.isReport = false;
                    }
                });
            }
        }
        vm.generateArchingPdf = function () {
            balanceUserService.getReportBalanceUserPdf(vm.type, vm.toDate, vm.filterArching.detail).then(function (response) {
                if(response !== undefined){
                    var filePdf = new Blob([response.data], { type: 'application/pdf'});
                    var nameFile = 'arching-' + (new Date()).getTime() + '.pdf';
                    if (window.navigator && window.navigator.msSaveOrOpenBlob){
                        window.navigator.msSaveBlob(filePdf, nameFile);
                    }else{
                        var fileURL = URL.createObjectURL(filePdf);
                        var a = document.createElement('a');
                        a.href = fileURL;
                        a.target = '_blank';
                        a.download = nameFile;
                        document.body.appendChild(a);
                        a.click();
                    }
                }

            });
        }

        vm.generateTransactionsPdfHtml = function (target) {
            printService.printPdfHtml(target);
        }

        vm.generateToExcel = function (contendId) {
            excelService.exportDataToExcel(contendId, vm.filterPassages.detail ? 'report_detail' : 'report_total');
        }

        vm.cancelGenerateArching = function(formGenerateArching) {
            vm.filterArching.currency = null;
            vm.filterArching.toDate = 1;
            vm.filterArching.type = {"1": false, "2": false, "3": false};
            vm.filterArching.detail = true;
            vm.reportBalanceHtml = '';
            vm.toDate = null;
            vm.type = '';
            vm.isReport = false;
            formGenerateArching.$setPristine();
        };

        function getRegions(regions,branchOffices){
            var regionsAux = [];
            angular.forEach(regions, function (region) {
                angular.forEach(branchOffices, function (branchOffice) {
                    if(linkService.getLinkId(region._links.self.href)== branchOffice.regionId){
                        var bandThereIsRegionId = false;
                        angular.forEach(regionsAux, function (regionAux) {
                            if(linkService.getLinkId(region._links.self.href)== linkService.getLinkId(regionAux._links.self.href)){
                                bandThereIsRegionId = true;
                            }
                        })
                        if(!bandThereIsRegionId){
                            regionsAux.push(region);
                        }
                    }
                })
            })
            return regionsAux;
        }

        function getBranchOffices(branchOffices,sessionBranchOffices){
            var branchOfficesAux = [];
            angular.forEach(branchOffices, function (branchOffice) {
                angular.forEach(sessionBranchOffices, function (sessionBranchOffice) {
                    if(linkService.getLinkId(branchOffice._links.self.href)== linkService.getLinkId(sessionBranchOffice._links.self.href)){
                        branchOfficesAux.push(branchOffice);
                    }
                })
            })
            return branchOfficesAux;
        }

        function getUsers(users,sessionUser){
            var usersAux = [];
            angular.forEach(users, function (user) {
                if(linkService.getLinkId(user._links.self.href)== linkService.getLinkId(sessionUser._links.self.href)){
                    usersAux.push(user);
                }

            })
            return usersAux;
        }
    }
})();
